import React from 'react';
import { IIconProps } from '../interfaces';

const AleaHardwareLivingAreaIcon: React.FC<IIconProps> = ({
  color = '#2B4956',
  size = 40,
}) => {
  const width = (34 / 40) * Number(size);
  const height = size;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 34 40"
      fill="none"
    >
      <path
        d="M0.646729 15.5611C0.646729 14.7206 1.0089 13.9209 1.64059 13.3665L14.7806 1.83404C15.8826 0.866882 17.5309 0.866883 18.6329 1.83404L31.7729 13.3665C32.4046 13.9209 32.7667 14.7206 32.7667 15.5611V35.7676C32.7667 37.3802 31.4594 38.6876 29.8467 38.6876H3.56673C1.95406 38.6876 0.646729 37.3802 0.646729 35.7676V15.5611Z"
        fill="white"
        stroke={color}
      />
      <path
        d="M16.2053 14.5352V32.0552"
        stroke={color}
        strokeWidth="6.37728"
        strokeMiterlimit="10"
      />
      <path
        d="M24.9653 23.2949H7.44531"
        stroke={color}
        strokeWidth="6.37728"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default AleaHardwareLivingAreaIcon;
